import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

/**
 * Campo de text area
 */
@Component({
    selector: 'app-textarea',
    template: `
      <div [formGroup]="form">
        <textarea [class.is-invalid]="isDirty && !isValid" [formControlName]="field.name" [id]="field.name"
        [ngClass]="{'is-invalid': isTouched && !isValid && field.required}"
        [attr.disabled]="field.disabled" [maxlength]="field.maxLength"
        rows="4" class="form-control" [placeholder]="field.placeholder || ''" [value]="field.value"></textarea>
      </div>
    `,
    standalone: false
})
export class TextareaComponent {
  /**
   * Campo del formulario
   */
  @Input() field: any = {};
  /**
   * Formulario
   */
  @Input() form!: UntypedFormGroup;

  /**
   * Indica si es valido
   */
  get isValid(): any {
    return this.form.controls[this.field.name].valid;
  }
  /**
   * Indica si esta sucio
   */
  get isDirty(): any {
    return this.form.controls[this.field.name].dirty;
  }
  /**
   * Indica si fue tocado
   */
  get isTouched(): any {
    return this.form.controls[this.field.name].touched;
  }

}
